import { render, staticRenderFns } from "./ChatUpFile.vue?vue&type=template&id=a5edd4ce&scoped=true&"
import script from "./ChatUpFile.vue?vue&type=script&lang=js&"
export * from "./ChatUpFile.vue?vue&type=script&lang=js&"
import style0 from "./ChatUpFile.vue?vue&type=style&index=0&id=a5edd4ce&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5edd4ce",
  null
  
)

export default component.exports